/**
 * Konfigurierbare Endpoints für den OAuth2-Client.
 *
 * **Auflösung der Base-URLs:**
 *   - `r2BaseUrl`    = aktueller `window.location.origin` (z.B. https://r2.handyshop.cc.localhost)
 *   - `oauthBaseUrl` = abgeleitet aus `r2BaseUrl` durch Sub-Domain-Swap
 *                      (`r2.` → `oauth.`)
 *
 * Konvention: in allen Umgebungen (lokal/test/live) ist R2 unter `r2.<rest>`
 * und der OAuth-Server unter `oauth.<rest>` erreichbar. So bleibt der Build
 * identisch über alle Stages — kein VITE-Override, kein .env.local nötig.
 *
 * Überschreibbar (für Spezialfälle) via Vite-Env-Variablen (siehe env.d.ts):
 *   VITE_OAUTH_BASE_URL, VITE_R2_BASE_URL, VITE_OAUTH_CLIENT_ID
 */

const env = import.meta.env;

function deriveR2BaseUrl(): string {
  if (env.VITE_R2_BASE_URL) return env.VITE_R2_BASE_URL;
  // Standardfall: SPA läuft genau auf der R2-Subdomain.
  return window.location.origin;
}

function deriveOauthBaseUrl(r2Url: string): string {
  if (env.VITE_OAUTH_BASE_URL) return env.VITE_OAUTH_BASE_URL;
  // dirty but effective: r2.<host> → oauth.<host>.
  // Matched nur das `://r2.`-Präfix, damit z.B. „r2"-Vorkommen im
  // restlichen Hostnamen nicht versehentlich getroffen werden.
  return r2Url.replace(/:\/\/r2\./, '://oauth.');
}

const r2BaseUrl    = deriveR2BaseUrl();
const oauthBaseUrl = deriveOauthBaseUrl(r2BaseUrl);

export const config = {
  oauthBaseUrl,
  r2BaseUrl,
  clientId:     env.VITE_OAUTH_CLIENT_ID ?? 'r2-web',
  scope:        'profile',
  redirectPath: '/callback',
} as const;

export const endpoints = {
  authorize: `${config.oauthBaseUrl}/authorize`,
  token:     `${config.oauthBaseUrl}/token`,
  userinfo:  `${config.oauthBaseUrl}/userinfo`,
  logout:    `${config.oauthBaseUrl}/logout`,
} as const;

export const redirectUri      = `${config.r2BaseUrl}${config.redirectPath}`;
export const postLogoutUri    = `${config.r2BaseUrl}/`;
